var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCycle(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.91629 10.5927L6.68624 13.1573V15.3873C4.56769 14.3838 2.44915 12.0423 2.44915 9.2547C2.44915 5.79813 4.9022 2.89906 8.02427 2.56456L8.91629 2.45305V0L7.80126 0.111502C3.34117 0.669015 -0.00390625 4.5716 -0.00390625 9.2547C-0.00390625 12.2653 2.11464 15.3873 4.45619 16.7254H2.78365L0.442104 18.9554H8.91629V10.5927Z",
    fill: "#0A77A9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0312 8.36268L12.2613 5.79813V3.56808C14.3798 4.5716 16.4984 6.91315 16.4984 9.70071C16.4984 13.1573 14.0453 16.0564 10.9233 16.3909L10.0312 16.5024V18.9554L11.1463 18.8439C15.6064 18.2864 18.9514 14.3838 18.9514 9.70071C18.9514 6.69015 16.8329 3.56808 14.4913 2.23005H16.1639L18.5054 0H10.0312V8.36268Z",
    fill: "#0A77A9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCycle);
export default __webpack_public_path__ + "static/media/cycle.d7df7cdfe064ee459a114e4117e4d8b7.svg";
export { ForwardRef as ReactComponent };